import { logout } from "../app/Login/logout";
import { getConfig } from "../config";

// Helper to safely get base URL at runtime
function getBaseUrl(): string {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3004";
  }
  try {
    const { PAYMENT_SERVICE_URL } = getConfig();
    return PAYMENT_SERVICE_URL;
  } catch (err) {
    console.error("Config not loaded yet", err);
    return ""; // fallback or throw error if preferred
  }
}

const originalFetch = window.fetch;

export class FetchError extends Error {
  constructor(
    public status: number,
    public message: string,
    public context?: any,
  ) {
    super(message);
  }
}

export const paymentsFetch = async <T>(
  url: string,
  method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE" = "GET",
  body?: any,
  signal?: AbortSignal,
) => {
  const baseUrl = getBaseUrl();
  const input = `${baseUrl}${url}`;

  const response = await originalFetch(input, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    signal,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json();

  if (response.status === 401) {
    logout();
  }

  if (response.status >= 400) {
    throw new FetchError(response.status, `Failed to fetch ${method} @ ${url}`, data);
  }

  return data as T;
};
